<template>
  <div class="emails">
    <ba-header activeModule="Insured Messages"></ba-header>
    <div class="u-p4 main-content" v-loading="loading">
      <h2 class="c-heading__page u-mt4 u-pt2">Campaign details</h2>
      <div class="u-text--sm"> {{campaign_id}}</div>
      {{details}}
    </div>
  </div>

</template>

<script>
/* eslint-disable */
import axios from 'axios'
import config from '@/config'

export default {
  components: {
  },
  name: 'ba-insured-messages',
  data () {
    return {
      companyId: this.$route.params.companyId,
      loading: true,
      details: null,
    }
  },

  created () {
    this.loadInitial()
  },
  computed: {
    campaign_id () {
      return this.$route.query.campaign_id
    },
  },
  methods: {
    async loadInitial() {
      let url = config.url + `/company/${this.companyId}/campaign-details/${this.campaign_id}`
      try {
        let response = await axios.get(url)
        this.details = response.data
      }
      finally {
        this.loading = false
      }

    },
  },
}
</script>

<style scoped>
</style>

<style>
</style>

